<template>
    <modal size="medium" :closeable="false" :no-footer="true" state="bad" @close="$emit('close')">
        <template slot="header">
            <strong>Tenants Require Setup</strong>
        </template>

        <template slot="content">
            <div>
                <div v-if="cycles.length === 1">
                    <strong>⚠️ Reminder:</strong>

                    <span v-if="formattedCycles[0].stats.requires_setup === 1">1 tenant still requires setup for coverage prior to <strong>{{ formattedCycles[0].due_date }}</strong>.</span>
                    <span v-else>{{ formattedCycles[0].tenant_count }} tenants still require setup for coverage prior to <strong>{{ formattedCycles[0].due_date }}</strong>.</span>
                </div>

                <div v-else>
                    <div v-for="cycle in formattedCycles" :key="cycle.id" class="cycle-item">
                        <strong>⚠️ Reminder:</strong>

                        <span v-if="cycle.stats.requires_setup === 1">1 tenant in cycle <strong>{{ cycle.label }}</strong> still requires setup for coverage prior to <strong>{{ cycle.due_date }}</strong>.</span>
                        <span v-else>{{ cycle.tenant_count }} tenants in cycle <strong>{{ cycle.label }}</strong> still require setup for coverage prior to <strong>{{ cycle.due_date }}</strong>.</span>
                    </div>
                </div>
            </div>

            <div class="flex jc-fe mt-4">
                <button class="danger" type="type" @click="$emit('close')">Acknowledge</button>
            </div>
        </template>
    </modal>
</template>

<script>
import dayjs from "dayjs"

export default {
    props: {
        cycles: {
            required: true,
            type: Array
        }
    },

    data () {
        return {}
    },

    computed: {
        formattedCycles () {
            return this.cycles.map((cycle) => {
                return Object.assign(cycle, {
                    due_date: dayjs(cycle.setup_coverage_end_date).format("M/DD/YYYY"),
                    tenant_count: cycle.stats.requires_setup.toLocaleString()
                })
            })
        }
    }
}
</script>

<style scoped>
.cycle-item + .cycle-item {
    margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/home-page/ManagerSetupTenantsModal.vue